<template>
  <div>
    <v-main>
      <div class="bg">
        <v-container>
          <div class="center nav">
            <v-icon style="position: absolute; left: 20px" @click="previous()"
              >mdi-arrow-left</v-icon
            >
            <v-spacer></v-spacer>
            <h2 style="margin-bottom: 0">Login</h2>
            <v-spacer></v-spacer>
          </div>
          <div class="signUp">
            <div class="center" style="padding-bottom: 1rem">
              <v-btn
                style="background: var(--neutral-white, #fff)"
                large
                block
                class="btn-mail"
                to="/createAccount"
              >
                <img
                  style="width: 20px; height: 20px; margin: 0 10px"
                  :src="require('@/assets/icons8-google-48.png')"
                  alt=""
                />
                Sign Up with Google</v-btn
              >
            </div>
            <div class="center" style="padding-bottom: 1rem">
              <v-btn dark block large style="background: #0056b2" class="btn-face" @click="loginWithFacebook"
                ><v-icon style="padding-right: 10px">facebook</v-icon> Sign Up
                with Facebook</v-btn
              >
            </div>
            <!-- <div class="center" style="padding-bottom: 1rem">
              <v-btn
                large
                style="background: var(--neutral-white, #fff)"
                class="btn-face"
                ><img
                  style="width: 20px; height: 20px; margin: 0 10px"
                  :src="require('@/assets/icons8-google-48.png')"
                  alt=""
                />
                Sign Up with Google</v-btn
              >
            </div>
            <div class="center" style="padding-bottom: 1rem">
              <v-btn dark large style="background: #0056b2" class="btn-google" @click="loginWithFacebook"
                ><v-icon style="padding-right: 10px">facebook</v-icon> Sign Up
                with Facebook</v-btn>
            </div> -->
          </div>
          <v-container>
            <div class="row">
                    <v-divider style="display:flex;justify-content:center;align-items:center"></v-divider><p style="padding:0 15px;margin: 0;display:flex;align-items:center">OR</p><v-divider></v-divider>
            </div>
            </v-container>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
            <p style="padding-top:15px">Email Address</p>
            <v-text-field
            v-model="Email"
              prepend-inner-icon="mdi-email-outline"
              solo
              flat
              hide-details
              placeholder="Your email address"
              style="border-radius: 20px;padding-bottom:5px"
            ></v-text-field>
            <p style="padding-top:5px">Password</p>
            <v-text-field
            v-model="password"
              placeholder="Your password"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show2 ? 'text' : 'password'"
              solo
              flat
              hide-details
              style="border-radius: 20px"
              @click:append="showPass"
            ></v-text-field>
            </v-form>
            <div class="action" style="padding-top:30px">
                <v-btn class="Login" dark color="#25388D" style="height: 56px;" @click="login">Login</v-btn>
            </div>
        </v-container>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
export default {
  name: 'LoyaltySystemSignUp',

  data () {
    return {
      valid: true,
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        lenghth: v => v.length >= 8 || 'Must be at least 8 characters'
      },
      Email: '',
      password: '',
      show2: false
    }
  },

  mounted () {
    window.fbAsyncInit = function () {
    /* global FB */
      FB.init({
        appId: '579746187441654',
        cookie: true,
        xfbml: true,
        version: 'v17.0'
      })

      FB.AppEvents.logPageView()
    };

    (function (d, s, id) {
      // eslint-disable-next-line one-var
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) { return }
      js = d.createElement(s); js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  },

  methods: {
    openRegister () {
      window.location = 'http://localhost:8081/createAccount'
    },
    loginWithFacebook () {
      FB.login(
        response => {
          if (response.authResponse) {
            const userId = response.authResponse.userID
            console.log('Facebook user ID:', userId)
          } else {
            console.log('ผู้ใช้ยกเลิกการเข้าสู่ระบบหรือไม่อนุญาต')
          }
        },
        { scope: 'public_profile,email' }
      )
    },
    previous () {
      window.location = 'http://localhost:8081/login'
    },
    login () {
      axios
        .get(this.DNS_IP + '/system_shop/auth?userName=' + this.Email + '&userPassword=' + this.password)
        .then(response => {
          if (response.data.status === false) {
            this.$swal(
              'ไม่พบบัญชีผู้ใช้',
              'กรุณากรอกข้อมูลอีกครั้ง ',
              'error'
            )
            this.Email = ''
            this.password = ''
          } else {
            this.$session.start()
            this.$session.set('data', response.data[0])
            localStorage.clear()

            if (response.data[0].shopStatus === 'active') {
              if (this.$route.query.callBack) {} else {
                this.$router.push('/Master/AddCoin')
              }
              console.log(response.data[0].shopStatus)
            } else {
              this.dataBilling = response.data[0]
              this.dialogPaymentUpload = true
            }
          }
          console.log(response.data)
        })
    },
    showPass () {
      this.show2 = !this.show2
      console.log(this.show2)
    }
  }
}
</script>

<style scoped>
/*//////////////*/
.bg {
  background: var(--neutral-grey-5, #eef3fc);
  height: 100vh;
  display: flex;
  justify-content: center;
}
.center {
  display: flex;
  justify-content: center;
}
span {
  color: var(--neutral-grey-2, #858494);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
a {
  text-decoration: none;
  color: var(--color-primary, #25388d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.nav {
  display: flex;
  align-items: center;
  height: 100px;
}
.nav div {
  display: flex;
  align-items: center;
}
.iconn {
  display: flex;
  align-items: center;
}

.signUp {
  justify-content: center;
}
.btn-mail {
  border-radius: 20px;
  width: 327px;
  height: 24px;
}
.btn-face {
  border-radius: 20px;
  /* border: 2px solid var(--neutral-grey-4, #e6e6e6); */
  width: 327px;
}
.btn-google {
  border-radius: 20px;
  display: flex;
  width: 327px;
  padding: 16px 133px;
  justify-content: center;
  align-items: center;
  height: 24px;
}
.Login {
        border-radius: 20px;
        width: 100%;
        height: 24px;
        /* position: absolute;
        top: 85px; */
    }
.v-btn:not(.v-btn--round).v-size--large {
    height: 56px;
    min-width: 78px;
    padding: 0 19.5555555556px;
}
.v-btn:not(.v-btn--round).v-size--default {
    height: 56px;
    min-width: 64px;
    padding: 0 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/selectLogin.vue